import React, { useContext, useState, useEffect } from 'react'
import AuthContext from '../../context/AuthContext'
import { Redirect, } from "react-router-dom";
import flptslogot from '../../static/flptslogot.png';
import { InlineNotification, Link, Form, TextInput, Button, Tile } from 'carbon-components-react';

const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;

const API_URL =
  NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const Login = () => {
  let { loginUser, user, errorMessage } = useContext(AuthContext)

  let [clientIP, setClientIP] = useState("")

  const [invalidUsername, setInvalidUsername] = useState(false);
  const [invalidPassword, setInvalidPassword] = useState(false)

  let getClientIP = async () => {
    let response = await fetch(`${API_URL}/tools/ip/`)
    let data = await response.json()
    setClientIP(data)
  }

  useEffect(() => {
    document.title = "Sign In | WillowBMS"
    getClientIP()
  }, [])

  const handleUsernameChange = e => {
    if (e.target.value === "") {
      setInvalidUsername(true)
    } else {
      setInvalidUsername(false)
    }
  }

  const handlePasswordChange = e => {
    if (e.target.value === "") {
      setInvalidPassword(true)
    } else {
      setInvalidPassword(false)
    }
  }

  return (
    <div id="body" className="m-auto">
    <div style={{width:'315px', margin:'auto', position: 'realative'}}>
      {user && <Redirect to="/" />}
      <Tile className="bx--container" light="true">
        <div className="container-tight py-4">
          <div className="text-center mb-4">
            <Link to=""><img src="./static/logo.svg" height="36" alt="" /></Link>
          </div>
          <img class="logo-image mb-1" src={flptslogot} alt="FLPTS Logo" />
          <h3 className="text-center mb-4">Login</h3>
          {errorMessage && <InlineNotification
          kind="error"
        subtitle={errorMessage}
        timeout={0}
        hideCloseButton="true"
        title="Authentication Error: "
      />}
          <Form onSubmit={loginUser}>
            <div style={{ marginBottom: '2rem' }}>
              <TextInput
                required
                id="username"
                invalidText="Username is required"
                labelText="Username"
                placeholder="Enter your username"
                onChange={handleUsernameChange}
                invalid={invalidUsername}
              />
            </div>
            <div style={{ marginBottom: '2rem' }}>
              <TextInput.PasswordInput
                id="password"
                invalidText="Password is required"
                labelText="Password"
                placeholder="Enter your password"
                onChange={handlePasswordChange}
                invalid={invalidPassword}
              />
            </div>
            <div className='d-flex'>
              <Button
                kind="primary"
                tabIndex={0}
                type="submit"
              >
                Log in
              </Button>
              <Link className="ml-auto" href="/password-reset">Forgot password?</Link>
            </div>
            <div className="mt-3">
              <p><span className='strong'>Current IP: </span>{clientIP}</p>
            </div>
          </Form>
        </div>
      </Tile>
    </div>
    </div>
  )
}

export default Login